module.exports = __webpack_public_path__ + "static/media/inf_50og62.5dfb7a34.mp3";